import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined';
import HealingOutlined from '@mui/icons-material/HealingOutlined';
import PendingOutlined from '@mui/icons-material/PendingOutlined';
import DocPageLayout from './DocPageLayout.js';
import './DocPage.css';

const heroImage = '/img/nerve-therapy-trial.webp';
const secondaryImage = '/img/about-nerve-therapy.jpg';

const CampaignNerveTherapy = () => (
    <DocPageLayout
        currentRoute="/campaign/nerve-therapy-trial"
        pageLabel="CAMPAIGN"
        pageTitle="神経整体25分 お試しキャンペーン"
        heroImage={heroImage}
        heroImageAlt="神経整体のお試し施術の様子"
        heroHighlight="神経にダイレクトに働きかけ、瞬時に変化を引き出す施術"
        heroDescription={[
            '神経整体で身体本来のバランスを取り戻し、不調の根本改善を目指します。',
            '初めての方でも安心して受けられるやさしい刺激で、原因へ直接アプローチします。'
        ]}
    >
        <article className="doc-section">
            <h3 className="doc-section__title">
                <LocalOfferOutlined className="doc-section__icon" />キャンペーン概要
            </h3>
            <div className="doc-section__body">
                <p>
                    お体の不調や痛みでお悩みの方へ「神経整体」の効果を体験いただくための限定プランです。
                    予約ページから「キャンペーン 神経整体お試し」を選択してください。
                </p>
                <div className="doc-highlight">
                    <p><strong>施術内容</strong> 神経整体 初回 50分 / 2回目以降 25分</p>
                    <p><strong>特別価格</strong> 7,700円 → 5,500円</p>
                    <p className="doc-note">※キャンペーンは予告なく終了する場合があります。</p>
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <HealingOutlined className="doc-section__icon" />神経整体について
            </h3>
            <div className="doc-section__body">
                <p>
                    身体を動かす「運動神経」、痛みを感じる「感覚神経」、内臓を調整する「自律神経」。
                    すべての根本は神経にあります。神経の流れを整えることで、慢性的な痛みや不調を根本から改善へ導きます。
                </p>
                <div className="doc-section__media">
                    <img src={secondaryImage} alt="神経整体の施術イメージ" loading="lazy" />
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <PendingOutlined className="doc-section__icon" />こんなお悩みに
            </h3>
            <div className="doc-section__body">
                <p>
                    慢性的な腰痛や肩こり、頭痛など、どこに行っても良くならなかった症状にお悩みの方におすすめです。
                    神経からアプローチすることで、根本改善と再発予防を目指します。
                </p>
            </div>
        </article>
    </DocPageLayout>
);

export default CampaignNerveTherapy;
